module.exports = __webpack_public_path__ + "static/media/IMG_3606.814a6e75.JPG";